export const DOCUMENT_TYPE_BRAND = 'commerce.brand';
export const BRAND_PAGE_ALL_SLUG = 'merker';
export const DOCUMENT_TYPE_BRAND_ALL_PAGE = 'commerce.brandAllPage';
export const BRAND_ALL_PAGE_ID = 'commerceBrandAllPage';
